import { Stack, Button, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import Animation from 'src/assets/animations/components/animation-wrapper';
import TickAnimationData from 'src/assets/animations/json/success-tick.json';
import { useRouter } from 'src/routes/hooks';
import PropTypes from 'prop-types';
import { getPublicOrganizationDetails } from 'src/services/user.service';
import { LoadingScreen } from 'src/components/loading-screen';
import { useResponsive } from 'src/hooks/use-responsive';

export default function AccountCreatedSuccessView({ orgId, userId, token }) {
  // hooks
  const router = useRouter();
  const mdUp = useResponsive('up', 'md');

  // states
  const [isLoading, setIsLoading] = useState(true);
  const [orgName, setOrgName] = useState('');

  // functions
  const getOrg = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getPublicOrganizationDetails(orgId);

      if (response.success) {
        setOrgName(response.body.name);
      } else {
        throw new Error(response.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, [orgId]);

  // effects
  useEffect(() => {
    (async () => {
      getOrg();
    })();
  }, [getOrg]);

  return (
    <Stack
      width="100%"
      height="100vh"
      alignItems="center"
      justifyContent="center"
    >
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <Stack alignItems="center" justifyContent="center" px="16px">
          <Animation
            height={mdUp ? 160 : 100}
            width={mdUp ? 160 : 100}
            animationData={TickAnimationData}
          />
          <Typography
            textAlign="center"
            variant={mdUp ? 'h3' : 'h4'}
            fontWeight={600}
            mb={{ xs: '12px', md: '16px' }}
          >
            Account Created Successfully
          </Typography>
          <Typography
            textAlign="center"
            variant={mdUp ? 'input' : 'caption'}
            color="content.primaryBlack3"
            mb={{ xs: '20px', md: '24px' }}
          >
            Your account created successfully. Please &apos;Sign In&apos; to
            access the dashboard.
          </Typography>
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              router.push('/auth/jwt/login');
            }}
          >
            Sign In
          </Button>
        </Stack>
      )}
    </Stack>
  );
}

AccountCreatedSuccessView.propTypes = {
  orgId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
};
